import { ChakraProvider, ChakraProviderProps } from '@chakra-ui/react';

export default function ChakraProviderWithoutResetCss(props: ChakraProviderProps) {
   // We want to funnel all ChakraProvider instances through this component
   // so that we can control the resetCSS prop from a single location.
   // eslint-disable-next-line react/forbid-elements
   return <ChakraProvider {...props} resetCSS={false} />;
}
